export default __webpack_public_path__ + "static/media/course4.6b67ea56.jpg";